var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_225_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C15.7281 13.5 18.75 10.4778 18.75 6.75C18.75 3.02217 15.7281 0 12 0C8.27236 0 5.25 3.02217 5.25 6.75C5.25 10.4778 8.27236 13.5 12 13.5ZM12 2.25C14.4814 2.25 16.5 4.26862 16.5 6.75C16.5 9.23128 14.4814 11.25 12 11.25C9.51872 11.25 7.5 9.23128 7.5 6.75C7.5 4.26862 9.51872 2.25 12 2.25ZM16.4999 15H7.50009C3.35808 15 0 18.3578 0 22.5C0 23.3284 0.671719 24 1.49991 24H22.5001C23.3283 24 24 23.3284 24 22.5C24 18.3578 20.6422 15 16.4999 15ZM2.30348 21.75C2.6685 19.2091 4.85981 17.25 7.50009 17.25H16.4999C19.1402 17.25 21.3316 19.2091 21.6966 21.75H2.30348Z",
    fill: "#6A798B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_225_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f3c94804c79f335d91576064b70319e5.svg";
export { ForwardRef as ReactComponent };